small
<template>
  <b-form-group :description="description" :label="label">
    <b-input-group dir="rtl" class="input-group-merge">
      <b-form-input v-bind="$attrs" v-on="$listeners" />
      <b-input-group-append is-text>
        <feather-icon
          v-if="$attrs.value && $attrs.value.length > 0"
          class="cursor-pointer"
          @click="$emit('input', '')"
          icon="XIcon"
        />
        <feather-icon v-else icon="SearchIcon" />
      </b-input-group-append>
    </b-input-group>
  </b-form-group>
</template>

<script>
import {
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
} from "bootstrap-vue";

export default {
  components: {
    BFormInput,
    BFormGroup,
    BInputGroupAppend,
    BInputGroup,
  },
  props: {
    label: String,
    description: String,
  },
  data() {
    return {};
  },
  computed: {
    defaultName() {
      return this.name || this.label;
    },
  },
};
</script>
